var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 262,
    viewBox: "0 0 256 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_1985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.878 133.451C255.878 122.717 255.007 114.884 253.122 106.761H130.55V155.209H202.497C201.047 167.249 193.214 185.381 175.807 197.565L175.563 199.187L214.318 229.21L217.003 229.478C241.662 206.704 255.878 173.196 255.878 133.451Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55 261.1C165.798 261.1 195.389 249.495 217.003 229.478L175.807 197.565C164.783 205.253 149.987 210.62 130.55 210.62C96.0268 210.62 66.7258 187.847 56.2808 156.37L54.7498 156.5L14.4518 187.687L13.9248 189.152C35.3928 231.798 79.4898 261.1 130.55 261.1Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.281 156.37C53.525 148.247 51.93 139.543 51.93 130.55C51.93 121.556 53.525 112.853 56.136 104.73L56.063 103L15.26 71.3115L13.925 71.9465C5.077 89.6435 0 109.517 0 130.55C0 151.583 5.077 171.455 13.925 189.152L56.281 156.37Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55 50.479C155.064 50.479 171.6 61.068 181.029 69.917L217.873 33.943C195.245 12.91 165.798 0 130.55 0C79.4898 0 35.3928 29.301 13.9248 71.947L56.1358 104.73C66.7258 73.253 96.0268 50.479 130.55 50.479Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_1985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 262,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.4ca9db837e5593e0b4429d5863b45cfa.svg";
export { ForwardRef as ReactComponent };